export default __webpack_public_path__ + "static/media/king.6d0ef6db.png";